import React from "react";

import withStyles from "@material-ui/styles/withStyles";

import {
  Create,
  Edit,
  List,
  Show,
  SimpleForm,
  SimpleShowLayout,
  ReferenceArrayInput,
  SelectArrayInput,
  FunctionField,
  TextInput,
  TextField,
  required,
  Datagrid,
  ShowButton,
  EditButton
} from "jazasoft";

const inputOptions = {
  xs: 12,
  sm: 3,
  fullWidth: true,
  options: { fullWidth: true }
};

const createStyle = theme => ({});

export const CreateTenant = withStyles(createStyle)(({ classes, ...props }) => {
  return (
    <Create {...props}>
      <SimpleForm className={classes.form} redirect="home">
        <TextInput source="name" validate={[required()]} {...inputOptions} />
        <TextInput source="tenantId" validate={[required()]} {...inputOptions} />
        <TextInput source="address" {...inputOptions} />
        <TextInput source="desc" {...inputOptions} />
        <ReferenceArrayInput label="Apps" source="appIds" reference="apps" xs={12} fullWidth>
          <SelectArrayInput />
        </ReferenceArrayInput>
      </SimpleForm>
    </Create>
  );
});

const editStyle = theme => ({});

export const EditTenant = withStyles(editStyle)(({ classes, ...props }) => {
  return (
    <Edit {...props}>
      <SimpleForm className={classes.form} redirect="home">
        <TextInput source="name" validate={[required()]} {...inputOptions} />
        <TextInput source="tenantId" validate={[required()]} {...inputOptions} />
        <TextInput source="address" {...inputOptions} />
        <TextInput source="desc" {...inputOptions} />
        <ReferenceArrayInput label="Apps" source="appIds" reference="apps" xs={12} fullWidth>
          <SelectArrayInput />
        </ReferenceArrayInput>
      </SimpleForm>
    </Edit>
  );
});

const fieldOptions = {
  xs: 12,
  sm: 3
};

const viewStyle = theme => ({
  show: {
    padding: "1.5em"
  }
});

export const ViewTenant = withStyles(viewStyle)(({ classes, ...props }) => {
  return (
    <Show {...props}>
      <SimpleShowLayout className={classes.show}>
        <TextField source="name" {...fieldOptions} />
        <TextField source="tenantId" {...fieldOptions} />
        <TextField source="address" {...fieldOptions} />
        <TextField source="desc" {...fieldOptions} />
        <FunctionField label="Apps" render={record => record.appList && record.appList.map(app => app.name).join(", ")} xs={12} fullWidth />
      </SimpleShowLayout>
    </Show>
  );
});

const homeStyle = theme => ({
  buttonEdit: {
    width: theme.spacing(14)
  },
  buttonDelete: {
    width: theme.spacing(16)
  }
});

export const TenantHome = withStyles(homeStyle)(({ classes, ...props }) => {
  return (
    <List {...props}>
      <Datagrid>
        <TextField source="name" />
        <TextField source="tenantId" />
        <FunctionField label="Apps" render={record => record.appList && record.appList.map(app => app.appId).join(", ")} />
        <ShowButton cellClassName={classes.buttonEdit} />
        <EditButton cellClassName={classes.buttonEdit} />
      </Datagrid>
    </List>
  );
});
